module.exports = __webpack_public_path__ + "media/images/flags/4x3/cze-52ba1c8f928b6e109657089d5b79fe5d.svg";